<template lang="pug">
.game.h-full
  nav.flex.bg-gray-700.p-6
    .flex.items-center.flex-shrink-0.text-white.mr-6
      span.font-semibold.text-xl.tracking-tight VorteX
    .block(class='sm:hidden')
      button.flex.items-center.px-3.py-2.border.rounded.text-gray-200.border-gray-400(class='hover:text-white hover:border-white')
        svg.fill-current.h-3.w-3(viewbox='0 0 20 20' xmlns='http://www.w3.org/2000/svg')
          title Menu
          path(d='M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z')
    .w-full.block.flex-grow(class='sm:flex sm:items-center sm:w-auto')
      .text-sm(class='sm:flex-grow')
        router-link.block.mt-4.text-orange-200.mr-4(to='/' class='sm:inline-block sm:mt-0 hover:text-white')
          | {{ $t('menu.home') }}
        router-link.block.mt-4.text-orange-200.mr-4(to='/starship' class='sm:inline-block sm:mt-0 hover:text-white')
          | {{ $t('menu.starship') }}
        router-link.block.mt-4.text-orange-200.mr-4(to='/ranking' class='sm:inline-block sm:mt-0 hover:text-white')
          | {{ $t('menu.ranking') }}
        router-link.block.mt-4.text-orange-200.mr-4(to='/profile' class='sm:inline-block sm:mt-0 hover:text-white')
          | {{ $t('menu.profile') }}
        //- a.block.mt-4.text-orange-200.mr-4(href='#' class='sm:inline-block sm:mt-0 hover:text-white')
        //-   | Alliances
        //- a.block.mt-4.text-orange-200(href='#' class='sm:inline-block sm:mt-0 hover:text-white')
        //-   | Settings

      .text-sm.text-right(class='sm:flex-grow' v-if="! isLoggedIn")
        .btn(@click="$router.push('/login')") Login

      .text-right(v-if="isLoggedIn")
        .user.flex.position-end
          img.mx-auto.rounded-full.w-12.h-12(:src="user.avatar")
          .text-left.px-4
            .name.text-lg.text-white.leading-none.mb-1.font-bold
              | {{ user.alias }}
              |
              span.text-gray-100 {{ user.code }}
            a.text-sm.text-white.leading-none(href="#" @click="$router.push('/login')") {{ $t('menu.settings') }}

  router-view

</template>

<script>
export default {
  name: 'App',
  computed: {
    user () {
      return this.$store.getters.user
    },
    isLoggedIn () {
      return this.$store.getters.isLoggedIn
    }
  }
}
</script>

<style lang="scss">
body {
  margin: 0;
  padding: 0;
  font-family: 'Nova Mono', monospace;
}

$grid-size: 80px;
$gutter: 4px;

.col-0, .col-1, .col-2, .col-3, .col-4, .col-5,
.col-6, .col-7, .col-8, .col-9, .col-10, .col-11,
.row-0, .row-1, .row-2, .row-3, .row-4, .row-5,
.row-6, .row-7, .row-8, .row-9, .row-10, .row-11 {
  position: absolute;
}

.row-0  { top: $gutter / 2 + $grid-size * -4; }
.row-1  { top: $gutter / 2 + $grid-size * -3; }
.row-2  { top: $gutter / 2 + $grid-size * -2; }
.row-3  { top: $gutter / 2 + $grid-size * -1; }
.row-4  { top: $gutter / 2 + $grid-size *  0; }
.row-5  { top: $gutter / 2 + $grid-size *  1; }
.row-6  { top: $gutter / 2 + $grid-size *  2; }
.row-7  { top: $gutter / 2 + $grid-size *  3; }

.col-0  { left: $gutter / 2 + $grid-size * -6; }
.col-1  { left: $gutter / 2 + $grid-size * -5; }
.col-2  { left: $gutter / 2 + $grid-size * -4; }
.col-3  { left: $gutter / 2 + $grid-size * -3; }
.col-4  { left: $gutter / 2 + $grid-size * -2; }
.col-5  { left: $gutter / 2 + $grid-size * -1; }
.col-6  { left: $gutter / 2 + $grid-size *  0; }
.col-7  { left: $gutter / 2 + $grid-size *  1; }
.col-8  { left: $gutter / 2 + $grid-size *  2; }
.col-9  { left: $gutter / 2 + $grid-size *  3; }
.col-10 { left: $gutter / 2 + $grid-size *  4; }
.col-11 { left: $gutter / 2 + $grid-size *  5; }

.builder {
  .btn-build {
    margin: 2px;
    height: 72px;
    width: 72px;
    display: inline-block;
    overflow: hidden;
    cursor: pointer;
  }
}

.area {
  display: block;
  height: 72px;
  width: 72px;
}

.bar-left {
  border-right: 1px solid #dddddd;
  padding: 20px;
}

.bar-right {
  border-left: 1px solid #dddddd;
  padding: 20px;
}

.btn-block.disabled {
  background-color: #dddddd;
  cursor: not-allowed;
}

.btn-block.available {
  background-color: #f39c00;
}

.btn-block.unavailable {
  background-color: #dddddd;
  color: #888888;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/App.vue